<template>
  <Content>
    <template v-slot:topbar>
      <AddUser />
    </template>

    <template v-slot:content>
      <template v-if="users && users.data.length > 0">
        <div class="sm:rounded-md mb-3">
          <ul role="list" class="">
            <template v-for="user in users.data" :key="user.id">
              <UserListItem :user="user" />
            </template>
          </ul>
        </div>

        <Pagination :meta="users.meta" :onPageChange="onPageChange" />
      </template>

      <template v-else>
          <p class="py-6 text-center dark:text-gray-300">
            Diemžēl nekas netika atrasts
          </p>
      </template>
    </template>
  </Content>
</template>

<script>
import { debounce } from 'vue-debounce'
import {mapGetters} from "vuex";
import Search from "@/services/Helpers/search";
import AddUser from "@/components/Users/AddUser"
import UserListItem from "@/components/Users/UserListItem";
import Pagination from "@/components/Components/Pagination";

export default {
  name: "Catalog",
  components: {
    AddUser,
    UserListItem,
    Pagination,
  },
  created() {
    this.$store.dispatch("setDataLoading", true)
  },
  mounted() {
    this.$store.dispatch('removeAllFormsForDisplay')
    this.$store.dispatch('resetSearch')
    const s = Search.getSearchQuery();
    if (s) {
      this.$store.dispatch('changeSearch', s)
      this.searchUsers()
    } else {
      this.$store.dispatch('getUsers', Search.getCurrentPage())
    }
  },
  computed: {
    ...mapGetters({
      users: 'users',
      formsForDisplay: 'formsForDisplay',
      search: 'search',
    })
  },
  watch: {
    search: function () {
      this.searchUsers()
    }
  },
  methods: {
    searchUsers: debounce(function () {
      this.$store.dispatch('changeSearch', this.search)
      this.$store.dispatch('getUsers', Search.getCurrentPage())
    }, 500),
    onPageChange(page) {
      this.$store.dispatch('getUsers', page);
      Search.changePage(this.users.meta.current_page)
    },
    showForm(formName){
      this.$store.dispatch('addFormForDisplay', formName)
    },
    displayForm(formName){
      return this.formsForDisplay.includes(formName)
    },
    hideAddUserForm(){
      this.$store.dispatch('removeAllFormsForDisplay')
    },
  }
}
</script>